import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const BatchEnrollmentInterface = () => {
  const [uploadStatus, setUploadStatus] = useState(null);
  const [fileName, setFileName] = useState('');
  const [validationResults, setValidationResults] = useState(null);

  const handleFileUpload = (event) => {
    const file = event?.target?.files?.[0];
    if (file) {
      setFileName(file?.name);
      setUploadStatus('processing');
      
      setTimeout(() => {
        setUploadStatus('success');
        setValidationResults({
          total: 156,
          valid: 148,
          invalid: 8,
          duplicates: 3
        });
      }, 2000);
    }
  };

  const handleDownloadTemplate = () => {
    console.log('Downloading CSV template...');
  };

  const handleProcessEnrollment = () => {
    console.log('Processing batch enrollment...');
    setUploadStatus('enrolled');
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 lg:p-8 shadow-elevation-2 border border-border">
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-1 md:mb-2">
            Employee Batch Enrollment
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">
            CSV upload with validation and enrollment tracking
          </p>
        </div>
        <div className="p-2 md:p-3 rounded-lg bg-primary/10">
          <Icon name="Upload" size={20} className="text-primary" />
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        <div className="border-2 border-dashed border-border rounded-lg p-6 md:p-8 text-center">
          <div className="flex flex-col items-center gap-3 md:gap-4">
            <div className="p-3 md:p-4 rounded-full bg-primary/10">
              <Icon name="FileSpreadsheet" size={32} className="text-primary" />
            </div>
            
            {!fileName ? (
              <>
                <div>
                  <p className="text-sm md:text-base font-medium text-foreground mb-1">
                    Upload Employee CSV File
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground">
                    Drag and drop or click to browse
                  </p>
                </div>
                <input
                  type="file"
                  accept=".csv"
                  onChange={handleFileUpload}
                  className="hidden"
                  id="csv-upload"
                />
                <label htmlFor="csv-upload">
                  <Button variant="outline" iconName="Upload" iconPosition="left" asChild>
                    <span>Select CSV File</span>
                  </Button>
                </label>
              </>
            ) : (
              <div className="w-full">
                <div className="flex items-center justify-center gap-2 mb-3">
                  <Icon name="FileCheck" size={20} className="text-success" />
                  <p className="text-sm font-medium text-foreground">{fileName}</p>
                </div>
                {uploadStatus === 'processing' && (
                  <div className="flex items-center justify-center gap-2">
                    <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
                    <p className="text-xs text-muted-foreground">Validating file...</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {validationResults && (
          <div className="bg-muted rounded-lg p-4 md:p-6">
            <h4 className="text-sm md:text-base font-semibold text-foreground mb-3 md:mb-4">
              Validation Results
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
              <div>
                <p className="text-xs text-muted-foreground mb-1">Total Records</p>
                <p className="text-lg md:text-xl font-bold text-foreground">{validationResults?.total}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Valid</p>
                <p className="text-lg md:text-xl font-bold text-success">{validationResults?.valid}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Invalid</p>
                <p className="text-lg md:text-xl font-bold text-error">{validationResults?.invalid}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Duplicates</p>
                <p className="text-lg md:text-xl font-bold text-warning">{validationResults?.duplicates}</p>
              </div>
            </div>
          </div>
        )}

        <div className="flex flex-col md:flex-row gap-3 md:gap-4">
          <Button 
            variant="outline" 
            iconName="Download" 
            iconPosition="left"
            onClick={handleDownloadTemplate}
            fullWidth
          >
            Download CSV Template
          </Button>
          {uploadStatus === 'success' && (
            <Button 
              variant="default" 
              iconName="UserPlus" 
              iconPosition="left"
              onClick={handleProcessEnrollment}
              fullWidth
            >
              Process Enrollment ({validationResults?.valid} employees)
            </Button>
          )}
        </div>

        {uploadStatus === 'enrolled' && (
          <div className="flex items-center gap-2 p-3 md:p-4 bg-success/10 border border-success/20 rounded-lg">
            <Icon name="CheckCircle" size={20} className="text-success" />
            <p className="text-xs md:text-sm text-success font-medium">
              Successfully enrolled {validationResults?.valid} employees
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BatchEnrollmentInterface;